<template>
  <div>
      <header>
            <nav class="navbar">
                <div class="container">
                    <h1 class="wthree-logo">
                        <a href="index.html" id="logoLink"><i class="fa fa-adjust"></i> <span>A</span>rtur</a>
                    </h1>

                    <!-- menu -->
                    <ul id="menu">
                        <li>
                            <input id="check02" type="checkbox" name="menu" />
                            <label for="check02"><span class="fa fa-bars" aria-hidden="true"></span></label>
                            <ul class="submenu">
                                <li><a href="index.html" class="active">Home</a></li>
                                <li><a href="#about">Sobre me</a></li>
                                <li><a href="#services">Serviços</a></li>
                                <li><a href="#experience">Experiência</a></li>
                                <li><a href="#portfolio">Portefólio</a></li>
                                <li><a href="#testimonials">Testemunhos</a></li>
                                <li><a href="#contact">Contacte-Me</a></li>
                            </ul>
                        </li>
                    </ul>
                    <!-- //menu -->

                </div>
            </nav>
        </header>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Header.vue